import { firebase, googleAuthProvider } from 'firebase/fbConfig';

class AuthService {
  static emailSignup = async ({ email, password }) => {
    return await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password);
  };

  static emailSignIn = async ({ email, password }) => {
    await firebase.auth().signInWithEmailAndPassword(email, password);
  };

  static passwordReset = async (email) => {
    await firebase.auth().sendPasswordResetEmail(email);
  };

  static googleLogin = async () => {
    await firebase.auth().signInWithPopup(googleAuthProvider);
  };

  static logout = async () => {
    await firebase.auth().signOut();
  };
}

export default AuthService;
